import { render } from "./PortfolioView.vue?vue&type=template&id=5cabf561&ts=true"
import script from "./PortfolioView.vue?vue&type=script&lang=ts"
export * from "./PortfolioView.vue?vue&type=script&lang=ts"

import "./PortfolioView.vue?vue&type=style&index=0&id=5cabf561&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__